import React from "react";

import { Icon } from "../../../components/Icon/Icon";
import { useNavigate } from "react-router-dom";
import { useInView } from "react-intersection-observer";
import { didElementTouchedTop } from "../../../lib/helpers/didElementTouchedTop";
import { useGlobalContext } from "../../../lib/context/GlobalContext/GlobalContext";

import OtherProducts from "../OtherProducts/OtherProducts";
import threeProductsHorizontal from "../../../assets/images/Infinite313x110/three-products-horizontal.png";
import office from "../../../assets/images/office.png";
import productWavesBlack from "../../../assets/images/Infinite313x110/product-waves-black.png";
import wifi6 from "../../../assets/images/wifi-6.png";
import product313x110 from "../../../assets/images/Infinite313x110/313x110.png";
import FlickitySlider from "../../../components/FlickitySlider/FlickitySlider";
import allProducts from "../../../assets/images/all-products.jpeg";
import productWallpaper from "../../../assets/images/Infinite313x110/313x110-wallpaper-wall.png";
import product313x110Top from "../../../assets/images/Infinite313x110/313x110-top.png";
import product313x110ShadowOne from "../../../assets/images/Infinite313x110/313x110-shadow-one.png";
import product313x110ShadowTwo from "../../../assets/images/Infinite313x110/313x110-shadow-two.png";
import product313x110ShadowThree from "../../../assets/images/Infinite313x110/313x110-shadow-three.png";

import cs from "classnames";

import "./Infinite110.scss";

const Infinite110 = () => {
  const navigate = useNavigate();
  const changeHeaderColor = useGlobalContext().changeHeaderColor;
  const [productSloganRef, productSloganVisibility] = useInView();
  const [productImageRef, productImageVisibility] = useInView();
  const [topSliderTitleRef, topSliderTitleVisibility] = useInView();
  const [topSliderRef, topSliderVisibility] = useInView();
  const [wifiSixTitleRef, wifiSixTitleVisibility] = useInView();
  const [wifiSixSubTitleRef, wifiSixSubTitleVisibility] = useInView();
  const [wifiSixImageRef, wifiSixImageVisibility] = useInView();
  const [threeProductsTitleRef, threeProductsTitleVisibility] = useInView();
  const [productOneRef, productOneVisibility] = useInView();
  const [productTwoRef, productTwoVisibility] = useInView();
  const [productThreeRef, productThreeVisibility] = useInView();
  const [officeHeadRef, officeHeadVisibility] = useInView();
  const [officeImageRef, officeImageVisibility] = useInView();
  const [otherProductsTitleRef, otherProductsTitleVisibility] = useInView();
  const [productHeaderRef, productHeaderVisibility] = useInView();
  const [officeRef, officeVisibility] = useInView();
  const [otherProductsRef, otherProductsVisibility] = useInView();

  didElementTouchedTop(".ProductHeader110Container", (value) => {
    if (productHeaderVisibility) {
      if (value) {
        changeHeaderColor("gray");
      } else {
        changeHeaderColor("white");
      }
    }
  });

  didElementTouchedTop(".Office110", (value) => {
    if (officeVisibility) {
      if (value) {
        changeHeaderColor("black");
      } else {
        changeHeaderColor("white");
      }
    }
  });

  didElementTouchedTop(".OtherProducts110", (value) => {
    if (otherProductsVisibility) {
      if (value) {
        changeHeaderColor("black");
      } else {
        changeHeaderColor("white");
      }
    }
  });

  return (
    <div className="InfiniteProduct110">
      <div className="ProductHeader110Container" ref={productHeaderRef}>
        <div className="ProductHeader110">
          <div className="ProductHeader110__container">
            <div className="ProductHeader110__left">
              <div
                className="ProductHeader110__products"
                onClick={() => {
                  navigate("/products");
                }}
              >
                Products
              </div>
              <Icon
                className="ProductHeader110__icon"
                icon="chevron-right-black"
              />
              <div className="ProductHeader110__product">Infinite 110</div>
            </div>
            <div className="ProductHeader110__right">
              <div className="ProductHeader110__design">Design</div>
              <div className="ProductHeader110__features">Features</div>
              <div className="ProductHeader110__specifications">
                Specifications
              </div>
            </div>
          </div>
        </div>
        <div className="ProductImage110">
          <div className="ProductImage110__container">
            <div
              ref={productSloganRef}
              className={cs(
                "ProductImage110__slogan",
                productSloganVisibility && "ProductImage110__slogan-animation",
              )}
            >
              <div className="ProductImage110__title">
                Infinite <span>110</span>
              </div>
              <div className="ProductImage110__subtitle">
                Unlocking Wi-Fi 6's Potential for Everyone
              </div>
            </div>

            <img
              ref={productImageRef}
              className={cs(
                "ProductImage110__image",
                productImageVisibility && "ProductImage110__image-animation",
              )}
              src={product313x110Top}
            />
          </div>
        </div>
      </div>

      <div className="TopSliderTitle110">
        <div
          ref={topSliderTitleRef}
          className={cs(
            "TopSliderTitle110__title",
            topSliderTitleVisibility && "TopSliderTitle110__title-animation",
          )}
        >
          Making Complex <span>Simple</span>
        </div>
      </div>

      <div
        ref={topSliderRef}
        className={cs(
          "TopSlider110",
          topSliderVisibility && "TopSlider110-animation",
        )}
      >
        <div className="TopSlider110__carts">
          <FlickitySlider
            options={{
              lazyLoad: 10,
              wrapAround: true,
              contain: true,
              draggable: true,
              autoPlay: true,
              freeScroll: true,
              imagesLoaded: true,
              // prevNextButtons: false,
            }}
          >
            <div className={cs("TopSlider110__cart", "TopSlider110__cartOne")}>
              <div className="TopSlider110__cartOne-textOne">
                Limitless Possibilities for Everyone
              </div>
              <img
                loading="lazy"
                src={threeProductsHorizontal}
                className="TopSlider110__cartOne-image"
              />
              <div className="TopSlider110__cartOne-textTwo">
                Infinite 110 offers robust and versatile connectivity, allowing
                users of all backgrounds to seamlessly broadcast, play games,
                and work across multiple devices simultaneously.
              </div>
            </div>
            <div className={cs("TopSlider110__cart", "TopSlider110__cartTwo")}>
              <div className="TopSlider110__cartTwo-textOne">
                Powerful Performance for All
              </div>
              <img loading="lazy" className="TopSlider110__cartTwo-image" />
              <div className="TopSlider110__cartTwo-textTwo">
                Fueled by the Qualcomm Atheros A53 Processor IPQ6018, Infinite
                110 ensures optimized networking applications, providing
                unparalleled processing power and efficiency accessible to all
                users.
              </div>
            </div>
            <div
              className={cs("TopSlider110__cart", "TopSlider110__cartThree")}
            >
              <div className="TopSlider110__cartThree-textOne">
                Stellar Connectivity, Universally
              </div>
              <div className="TopSlider110__cartThree-textTwo">
                Infinite 110 promises impressive data rates, delivering stellar
                connectivity accessible to users from all walks of life.
              </div>
            </div>
            <div className={cs("TopSlider110__cart", "TopSlider110__cartFour")}>
              <div className="TopSlider110__cartFour-textOne">
                Reliable Signal for Everyone
              </div>
              <img
                loading="lazy"
                src={office}
                className="TopSlider110__cartFour-image"
              />
              <div className="TopSlider110__cartFour-textTwo">
                In crowded environments such as shopping centers, Infinite 110
                maintains strong signal integrity, ensuring uninterrupted
                connectivity for all users, regardless of location.
              </div>
            </div>
            <div className={cs("TopSlider110__cart", "TopSlider110__cartFive")}>
              <div className="TopSlider110__cartFive-textOne">
                High-Speed Dual-Band Experience for All
              </div>
              <img
                loading="lazy"
                src={productWavesBlack}
                className="TopSlider110__cartFive-image"
              />
              <div className="TopSlider110__cartFive-textTwo">
                Enjoy lightning-fast speeds of 1.2 Gbps on the 5GHz band and
                dependable connectivity at 573 Mbps on the 2.4GHz band, catering
                to the diverse needs of users everywhere.
              </div>
            </div>
            <div className={cs("TopSlider110__cart", "TopSlider110__cartSix")}>
              <div className="TopSlider110__cartSix-textOne">
                Effortless Management, Universally
              </div>
              <img loading="lazy" className="TopSlider110__cartSix-image" />
              <div className="TopSlider110__cartSix-textTwo">
                With intuitive software control, managing devices becomes
                effortless for users of all skill levels, enabling remote
                adjustments, real-time monitoring, and notifications for
                enhanced accessibility universally.
              </div>
            </div>
          </FlickitySlider>
        </div>
      </div>

      <div className="WifiSix110">
        <div className="WifiSix110__container">
          <img
            ref={wifiSixTitleRef}
            loading="lazy"
            className={cs(
              "WifiSix110__title",
              wifiSixTitleVisibility && "WifiSix110__title-animation",
            )}
            src={wifi6}
          />
          <div
            ref={wifiSixSubTitleRef}
            className={cs(
              "WifiSix110__subtitle",
              wifiSixSubTitleVisibility && "WifiSix110__subtitle-animation",
            )}
          >
            Tailored to offer unmatched connectivity, even in the most rigorous
            settings, Wi-Fi 6 for all ensures exceptional performance for
            everyone, everywhere.
          </div>
          <div className="WifiSix110__body">
            <img
              ref={wifiSixImageRef}
              loading="lazy"
              className={cs(
                "WifiSix110__image",
                wifiSixImageVisibility && "WifiSix110__image-animation",
              )}
              src={product313x110}
            />
          </div>
        </div>
      </div>

      <div className="ThreeProductsTitle110">
        <div
          ref={threeProductsTitleRef}
          className={cs(
            "ThreeProductsTitle110__title",
            threeProductsTitleVisibility &&
              "ThreeProductsTitle110__title-animation",
          )}
        >
          Maximizing Business Connectivity with Affordable Excellence
        </div>
      </div>

      <div className="ThreeProducts110">
        <div className="ThreeProducts110__container">
          <div
            ref={productOneRef}
            className={cs(
              "ThreeProducts110__section",
              productOneVisibility && "ThreeProducts110__section-animation",
            )}
          >
            <div className="ThreeProducts110__text">
              <div className="ThreeProducts110__text-title">
                Design Excellence
              </div>
              <div className="ThreeProducts110__text-description">
                Infinite 110 boasts a contemporary and versatile design,
                seamlessly integrating into any business setting, whether it's
                stadiums, malls, or office spaces.
              </div>
            </div>
            <img
              className="ThreeProducts110__image"
              src={product313x110ShadowOne}
            />
          </div>{" "}
          <div
            ref={productTwoRef}
            className={cs(
              "ThreeProducts110__section",
              productTwoVisibility && "ThreeProducts110__section-animation",
            )}
          >
            <img
              className="ThreeProducts110__image"
              src={product313x110ShadowTwo}
            />

            <div className="ThreeProducts110__text">
              <div className="ThreeProducts110__text-title">
                High-Speed Performance
              </div>
              <div className="ThreeProducts110__text-description">
                With Wi-Fi 6 technology, Infinite 110 ensures rapid speeds,
                guaranteeing seamless and uninterrupted connectivity for users
                across various devices and applications in any business
                environment.
              </div>
            </div>
          </div>{" "}
          <div
            ref={productThreeRef}
            className={cs(
              "ThreeProducts110__section",
              productThreeVisibility && "ThreeProducts110__section-animation",
            )}
          >
            <div className="ThreeProducts110__text">
              <div className="ThreeProducts110__text-title">
                Reliable Support and Management
              </div>
              <div className="ThreeProducts110__text-description">
                Infinite 110 provides robust reliability and support, alongside
                intuitive software control. Businesses can efficiently manage
                and monitor their network settings remotely, ensuring optimal
                performance and peace of mind.
              </div>
            </div>
            <img
              className="ThreeProducts110__image"
              src={product313x110ShadowThree}
            />
          </div>
        </div>
      </div>

      <div ref={officeRef} className="Office110">
        <div className="Office110__container">
          <div
            ref={officeHeadRef}
            className={cs(
              "Office110__head",
              officeHeadVisibility && "Office110__head-animation",
            )}
          >
            <div className="Office110__head-left">
              The premier choice <br /> for business access points.
            </div>
            <div className="Office110__head-right">
              <div className="Office110__head-right-left">+30</div>
              <div className="Office110__head-right-right">
                Tailored for all settings, including large areas like malls,
                with the added benefit of accommodating numerous smartphones and
                devices at an affordable cost.
              </div>
            </div>
          </div>
          <img
            ref={officeImageRef}
            loading="lazy"
            className={cs(
              "Office110__image",
              officeImageVisibility && "Office110__image-animation",
            )}
            src={office}
          />
        </div>
      </div>

      <div className="Specifications110">
        <div className="Specifications110__container">
          <div className="Specifications110__title">Specifications</div>
          <div className="Specifications110__subtitle">Hardware</div>
          <div className="Specifications110__section">
            <div className="Specifications110__section-left">
              <div className="Specifications110__section-title">
                Wi-Fi Chipset
              </div>
            </div>
            <div className="Specifications110__section-right">
              <div className="Specifications110__section-description">
                Qualcomm Processor IPQ6018
              </div>{" "}
              <div className="Specifications110__section-description">
                2.4GHz Wi-Fi 6 band (2x2) , 573.5Mbps
              </div>
              <div className="Specifications110__section-description">
                5GHz Wi-Fi 6 band (2x2) , 1126.5Mbps
              </div>
              <div
                className={cs(
                  "Specifications110__section-description",
                  "Specifications110__section-description-borderNone",
                )}
              >
                5.2dBi x 7dBi internal 2.4GHz & 5GHz dual band antenna
              </div>
            </div>
          </div>

          <div className="Specifications110__section">
            <div className="Specifications110__section-left">
              <div className="Specifications110__section-title">
                Device Interfaces
              </div>
            </div>
            <div className="Specifications110__section-right">
              <div className="Specifications110__section-description">
                2x 1Gbps Ethernet Port (Active PoE)
              </div>
              <div className="Specifications110__section-description">
                1x Reset Button
              </div>
              <div className="Specifications110__section-description">
                1x DC Jack
              </div>{" "}
              <div
                className={cs(
                  "Specifications110__section-description",
                  "Specifications110__section-description-borderNone",
                )}
              >
                Maximum Power Consumption 14W
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="ImageSlider110">
        <FlickitySlider
          options={{
            lazyLoad: 10,
            wrapAround: true,
            contain: true,
            draggable: true,
            autoPlay: true,
            freeScroll: true,
            imagesLoaded: true,
            prevNextButtons: false,
          }}
        >
          <div className="ImageSlider110__image-container">
            <img
              loading="lazy"
              className="ImageSlider110__image"
              data-flickity-lazyload={allProducts}
            />
          </div>
          <div className="ImageSlider110__image-container">
            <img
              loading="lazy"
              className="ImageSlider110__image"
              data-flickity-lazyload={productWallpaper}
            />
          </div>
          <div className="ImageSlider110__image-container">
            <img
              loading="lazy"
              className="ImageSlider110__image"
              data-flickity-lazyload={allProducts}
            />
          </div>
          <div className="ImageSlider110__image-container">
            <img
              loading="lazy"
              className="ImageSlider110__image"
              data-flickity-lazyload={productWallpaper}
            />
          </div>
        </FlickitySlider>
      </div>

      <div ref={otherProductsRef} className="OtherProducts110">
        <div className="OtherProducts110__container">
          <div
            ref={otherProductsTitleRef}
            className={cs(
              "OtherProducts110__title",
              otherProductsTitleVisibility &&
                "OtherProducts110__title-animation",
            )}
          >
            Other Products
          </div>
          <OtherProducts />
        </div>
      </div>
    </div>
  );
};

export default Infinite110;
